import type { SVGProps } from "react";

/**
 * Opper's mark (the leaf-and-star symbol of the opper.ai wordmark), redrawn
 * as a single currentColor path on a square box.
 * Source: https://opper.ai (header logo SVG).
 */
export function OpperMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="-49.5 0 315 315" fill="currentColor" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.78 315C71.53 315 0 244.49 0 157.5C0 -18.9499 159.78 0.650075 159.78 0.650075C159.78 87.2201 88.36 157.4 0.2 157.5C149.8 157.64 159.78 315 159.78 315ZM160.52 217.98C160.52 217.98 156.94 161.65 105.04 157.52C120.6 157.34 160.52 151.54 160.52 96.5601C160.52 151.54 200.44 157.34 216 157.52C164.1 161.63 160.52 217.98 160.52 217.98Z"
      />
    </svg>
  );
}
